import { EnumSchema } from '../metadata-schema';

export const CohortrendementTotNiveau: EnumSchema = {
	"type": "string",
	"title": "CohortrendementTotNiveau",
	"enum": [
		"Onder niveau",
		"Onder niveau (prognose)",
		"Op niveau",
		"Op niveau (prognose)",
		"Boven niveau",
		"Boven niveau (prognose)"
	]
};
